import {Component, h, Listen, Prop, State} from '@stencil/core';
import NavLeft from "../svg-elements/nav-left";
import NavRight from "../svg-elements/nav-right";

@Component({
    tag: 'rtr-gallery',
    styleUrl: 'style.sass',
    shadow: false,
})
export class RtrGallery {
    @Prop() images: string[]
    @Prop() onImageClick: (index: number) => void

    @State() galleryLoaded: boolean = false
    @State() imageIndex: number = 0
    @State() containerWidth: number = 0

    imagesContainer: HTMLDivElement
    imageContainer: HTMLDivElement[] = []
    scrollTimer;

    @Listen('resize', {target: 'window'})
    handleWindowsResized() {
        this.containerWidth = this.imagesContainer.clientWidth
    }

    componentDidLoad = () => {
        this.galleryLoaded = true
    }

    componentDidRender = () => {
        this.containerWidth = this.imagesContainer.clientWidth
    }

    handleNavClick = (index) => {
        this.imageContainer[index].scrollIntoView({behavior: "smooth", block: "nearest"})
    }

    handleScroll = (e) => {
        const position = e.target.scrollLeft
        const index = Math.floor(position / this.containerWidth)
        if (index !== this.imageIndex) {
            clearTimeout(this.scrollTimer)
            this.scrollTimer = setTimeout(
                () => {
                    this.imageIndex = index
                },
                50
            )
        }
    }

    get renderDots() {
        if (this.images.length <= 1) {
            return null
        }

        return (
            <div class="RGCNav">
                {this.images.map((_, index) => {
                    const currentSelected = index === this.imageIndex
                    const indClass = currentSelected ?
                        "RGCIndicator RGCIndicatorSelected" :
                        "RGCIndicator"

                    return (
                        <div
                            class={indClass}
                            onClick={() => this.handleNavClick(index)}
                        />
                    )
                })}
            </div>
        )
    }

    get renderNavLeft() {
        if (this.images.length <= 1) {
            return null
        }

        const leftClass = this.imageIndex === 0 ?
            "RGCNavLeft RGCNavDisabled" :
            "RGCNavLeft"

        return (
            <div
                onClick={() => this.handleNavClick(this.imageIndex - 1)}
                class={leftClass}
            >
                <NavLeft/>
            </div>
        )
    }

    get renderNavRight() {
        if (this.images.length <= 1) {
            return null
        }

        const rightClass = this.images.length - 1 === this.imageIndex ?
            "RGCNavRight RGCNavDisabled" :
            "RGCNavRight"

        return (
            <div
                onClick={() => this.handleNavClick(this.imageIndex + 1)}
                class={rightClass}
            >
                <NavRight/>
            </div>
        )
    }

    render() {
        return (
            <div class="RGContainer">
                <div
                    ref={el => this.imagesContainer = el}
                    class="RGImages"
                    onScroll={this.handleScroll}
                >
                    {this.galleryLoaded &&
                        this.images.map((image, index) => {
                            return (
                                <div
                                    class="RGImage"
                                    style={{width: this.containerWidth + "px"}}
                                    ref={el => this.imageContainer[index] = el}
                                    onClick={() => this.onImageClick?.(index)}
                                >
                                    <rentware-image
                                        src={image}
                                        autoSize={true}
                                    />
                                </div>
                            )
                        })
                    }
                </div>

                {this.renderNavLeft}
                {this.renderNavRight}
                {this.renderDots}
            </div>
        )
    }
}
